/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Приоритет уведомления. Влияет на порядок обработки:
 * при одинаковом scheduled_at более высокий приоритет обрабатывается первым.
 * Переименован в NotificationPriority, чтобы избежать конфликта имён
 * с Notifier.Domain.Enums.Priority в C#.
 * @export
 * @enum {string}
 */
export enum NotifierNotificationPriority {
    Low = 0,
    Normal = 1,
    High = 2,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfNotifierNotificationPriority(value: any): boolean {
    for (const key in NotifierNotificationPriority) {
        if (Object.prototype.hasOwnProperty.call(NotifierNotificationPriority, key)) {
            if (NotifierNotificationPriority[key as keyof typeof NotifierNotificationPriority] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NotifierNotificationPriorityFromJSON(json: any): NotifierNotificationPriority {
    return NotifierNotificationPriorityFromJSONTyped(json, false);
}

export function NotifierNotificationPriorityFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotifierNotificationPriority {
    return json as NotifierNotificationPriority;
}

export function NotifierNotificationPriorityToJSON(value?: NotifierNotificationPriority | null): any {
    return value as any;
}

export function NotifierNotificationPriorityToJSONTyped(value: any, ignoreDiscriminator: boolean): NotifierNotificationPriority {
    return value as NotifierNotificationPriority;
}

